/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Law9Inputs */

const en__field__enum_studyprograms_study_law9 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Law9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Law`)
};

const de__field__enum_studyprograms_study_law9 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Law9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "Law" |
*
* @param {_Field__Enum_Studyprograms_Study_Law9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_law9 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Law9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Law9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_law9(inputs)
	return de__field__enum_studyprograms_study_law9(inputs)
});
export { _field__enum_studyprograms_study_law9 as "_field__enum_studyPrograms_STUDY_LAW" }